import { SUPPORT_EMAIL } from "../../config/links";

export const MailLink = ({ className = "", ...rest }) => (
  <a href={`mailto:${SUPPORT_EMAIL}`} className={`font-medium text-[var(--gold)] underline decoration-[rgba(232,184,74,0.5)] underline-offset-4 transition-colors hover:text-[#fff3cc] ${className}`} {...rest}>
    {SUPPORT_EMAIL}
  </a>
);

export const WithEmail = ({ text }) => {
  const parts = text.split(SUPPORT_EMAIL);
  return parts.map((p, i) => (
    <span key={i}>
      {p}
      {i < parts.length - 1 && <MailLink />}
    </span>
  ));
};
